import { AvatarSkeleton, TextSkeleton } from '@/components/Skeleton';

import { fontStyles } from '@/styles/typography';

import { TokenAvatar } from '@/ui/Avatars/TokenAvatar';

import type { TokenResult } from '@/utils/0x/token-registry.types';
import { formatShortAddress } from '@/utils/address';
import { truncate } from '@/utils/string';

export const Metadata = ({ token }: { token: TokenResult | undefined }) => {
  if (!token) return <MetadataLoadingSkeleton />;

  const { address, chainId, name, symbol, launchpad } = token;

  return (
    <div className="pt-4 px-4">
      <TokenAvatar
        address={address}
        chainId={chainId}
        launchpad={launchpad?.name}
        size={32}
        className="justify-self-start mb-2"
      />
      <div className="items-center flex min-w-0">
        <h5
          className={fontStyles({
            variant: 'H5',
            class: [`overflow-hidden text-ellipsis whitespace-nowrap`],
          })}
        >
          {truncate(name, 16, true)}
        </h5>
        <p
          className={fontStyles({
            variant: 'LABEL_MD',
            class: [
              'uppercase ml-1 text-token-gray-700 overflow-hidden text-ellipsis whitespace-nowrap',
            ],
          })}
        >
          {truncate(symbol, 8, true)}
        </p>
      </div>

      <p className={fontStyles({ variant: 'BODY_MD', class: ['mt-0.5 text-token-gray-800'] })}>
        {formatShortAddress(address, 6, 6)}
      </p>
    </div>
  );
};

const MetadataLoadingSkeleton = () => {
  return (
    <div className="pt-4 px-4">
      <div className="mb-2 p-0">
        <AvatarSkeleton size={32} />
      </div>

      <div className="items-center flex gap-2">
        <TextSkeleton width={120} height={24} />
        <TextSkeleton width={40} height={16} />
      </div>

      <TextSkeleton width={140} height={22} className="mt-0.5" />
    </div>
  );
};
